/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamLoungeResponse } from './oralExamLoungeResponse';

export type GenericApiResponseOralExamLoungeResponseData = OralExamLoungeResponse | null;
